import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import RequirePermission from "components/util-components/RequirePermission";
import { PERMISSIONS } from "functions/permissions";
import All from "./all";
import PendingCustomers from "./pending";
import Audiences from "./audiences";
import AudienceDetail from "./audiences/detail";
import CustomerMap from "./map";

const PARENT_URL = "/cms/customers";

// De groep zit al achter CUSTOMERS_VIEW (app-views/index.js); hier de
// fijnere rechten: wachtend en doelgroepen zijn beheer, de kaart apart.
const Customers = () => {
  return (
    <Routes>
      <Route path={`/all`} element={<All />} />
      <Route
        path={`/pending`}
        element={
          <RequirePermission permission={PERMISSIONS.CUSTOMERS_PENDING}>
            <PendingCustomers />
          </RequirePermission>
        }
      />
      <Route
        path={`/map`}
        element={
          <RequirePermission permission={PERMISSIONS.CUSTOMERS_MAP}>
            <CustomerMap />
          </RequirePermission>
        }
      />
      <Route
        path={`/audiences`}
        element={
          <RequirePermission permission={PERMISSIONS.CUSTOMERS_AUDIENCES}>
            <Audiences />
          </RequirePermission>
        }
      />
      <Route
        path={`/audiences/:id`}
        element={
          <RequirePermission permission={PERMISSIONS.CUSTOMERS_AUDIENCES}>
            <AudienceDetail />
          </RequirePermission>
        }
      />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/all`} replace />} />
    </Routes>
  );
};

export default Customers;
